const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSectionRemover`,
			DefaultInputExtensions: [ 'MaterialsTestSectionRemover' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSectionRemover {~D:Record.Hash~} -->
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} pt-0 pb-0">
				<a id="SECTION-REMOVER-FOR-{~D:Record.Macro.RawHTMLID~}"
					class="button is-ghost has-text-danger is-pulled-right p-0 is-size-7"
					title="Remove this test and its section from the form"
					onclick="{~P~}.providers.MaterialsTestSectionRemover.requestSectionRemoval('{~D:Record.PictForm.SectionRemovalHash~}')">
					<span class="icon"><i class="fas fa-trash-alt"></i></span><span class="icon-text">Remove Test</span>
				</a>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSectionRemover`,
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSectionRemover {~D:Record.Hash~} (not available in read mode) -->
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSectionRemover`,
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSectionRemover {~D:Record.Hash~} (not rendered in print mode) -->
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
